import React, { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar/SearchBar";
import Table from "../components/Table/Table";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import ApiManager from "../ApiManager/ApiManager";
import { useNavigate } from "react-router-dom";
import Modal from "../components/Modal/Modal";
import ViewEntity from "../components/ViewEntity/ViewEntity";
import EditCompany from "../components/CompanyComponents/EditCompany";
import { useAuth } from "../components/AuthProvider";
import { hasPermission, ShowButton } from "../components/RoleBasedComponents";
import PERMISSIONS from "../permissions";
import { useComponentLoading } from "../utils/useComponentLoading";

function Companies() {
  const { userPermissions } = useAuth();
  const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();

  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('fetchCompanies', async (onProgress) => {
        onProgress(20, 'Fetching companies...');
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        const response = await ApiManager.getAllCompanies(params);
        onProgress(60, 'Processing data...');
        if (!response.ok) throw new Error("Failed to fetch companies");
        const json = await response.json();
        setData(json);
        setHasMorePages(json.length == 12);
        onProgress(100, 'Completed');
      });
    } catch (error) {
      console.error("Error fetching companies:", error);
      setHasMorePages(false);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleEdit = () => {
    console.log("Edit clicked for row:");
    setDetails(false);
    setEdit(true);
    setModalOpen(true);
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleSetContract = () => {
    if (rowId) {
      console.log("Set Contract clicked for row:", rowId);
      navigate(`/login/contract_form/${rowId}`);
    } else {
      console.error("No row selected");
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_COMPANY_UPDATE)) {
    buttons.push({ label: "Edit", onClick: () => handleEdit() });
  }

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_CONTRACT_CREATE)) {
    buttons.push({ label: "Set Contract", onClick: handleSetContract });
  }

  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "email", headerName: "Email" },
    { field: "city", headerName: "City" },
    { field: "state", headerName: "State" },
    { field: "phone", headerName: "Phone Number" },
  ];

  const rows = (data || []).map((item) => ({
    id: item.id,
    name: item.name,
    email: item.email,
    city: item.city,
    state: item.state,
    phone: item.phone,
  }));

  return (
    <div>
      {!isEdit ? (
        <div>
          <TopNavbar
            title="Companies"
            
          />
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
              paddingTop: "20px",
              height: "5vh",
            }}
          >
            {/* <SearchBar /> */}

            <ShowButton permission={PERMISSIONS.VENDOR_COMPANY_CREATE}>
              
                <button
                  className="custom-button"
                  onClick={() => handleClick("/login/new_company")}
                >
                  New Company
                </button>
              
            </ShowButton>
          </div>
          <Table
            table_columns={columns}
            rows={rows}
            setRowsId={setRowId}
            buttons={buttons}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            hasMorePages={hasMorePages}
            isLoading={isLoading('fetchCompanies')}
            loadingMessage={getMessage('fetchCompanies')}
            loadingProgress={getProgress('fetchCompanies')}
          />
          {isModalOpen && isDetails && (
            <div>
              <Modal isOpen={true} onClose={handleModalClose}>
                <ViewEntity
                  id={rowId}
                  fetchFunction={ApiManager.getCompany}
                  columns={columns}
                  entity="id"
                />
              </Modal>
            </div>
          )}
        </div>
      ) : (
        <EditCompany id={rowId} setEdit={setEdit} />
      )}
    </div>
  );
}

export default Companies;
